import { createContext, useEffect, useState } from "react";

var LanguageContext = createContext();

export const LanguageControl = ({ children }) => {
  const [language, setLanguage] = useState({ selectedLanguage: 'eng', data: {} });
  useEffect(() => {
    window.app_language = language
    window.app_setLanguage = setLanguage
  })
  return (
    <LanguageContext.Provider key={language?.selectedLanguage} value={{ language, setLanguage }}>


      <div>
        {children} {/* This will render the <img> tag passed as children */}
      </div>
    </LanguageContext.Provider>
  );
};